import { ReactElement } from 'react';

import { ICategory } from '@Hotels-at-Home/hah-fe-core/dist/types/category';
import get from 'lodash/get';
import classnames from 'classnames';
import AdaptiveImage from '@Hotels-at-Home/hah-fe-core/dist/components/AdaptiveImage';
import { sanitizeHtml } from '@Hotels-at-Home/hah-fe-core/dist/utils/sanitize';

interface IProps {
  category: ICategory;
}

const CategorySEO = ({ category }: IProps): ReactElement | null => {
  const seoCopy = category.seo_copy || [];
  const imgWidth = category.seo_copy_image_width || null;
  const imgHeight = category.seo_copy_image_height || null;

  const title = get(seoCopy, [0, 'value'], '');
  const imgAltText = title?.replace(/<[^>]*>?/gm, '');
  const description = get(seoCopy, [3, 'value'], '');
  const imgUrl = get(seoCopy, [2, 'value'], '');
  const imgUrlWebp = category.seo_copy_image_webp || '';

  if (!title || !description || !imgUrl) {
    return null;
  }

  return (
    <div id="category-footer" className={classnames('ctg-seo')}>
      <div className="ctg-stack-wrap">
        <div className="stack">
          {title && (
            <h2
              data-gsap="fade"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }}
              suppressHydrationWarning
            />
          )}
          {description && <p className="description">{description}</p>}
        </div>
      </div>
      {imgUrl && (
        <div className="ctg-img-wrap" data-gsap="fade">
          {/* TODO: Add proper image alt from a different attribute */}
          <AdaptiveImage
            src={imgUrl}
            src_webp={imgUrlWebp}
            alt={imgAltText}
            width={imgWidth}
            height={imgHeight}
            loading="lazy"
          />
        </div>
      )}
    </div>
  );
};

export default CategorySEO;
